<div
  tuiDropdownOpen
  class="dropdown-button-wrapper"
  [tuiDropdownMobile]="label"
  [(tuiDropdownOpen)]="isDropdownOpened"
  [tuiDropdown]="dropdownContent"
>
  <button
    *ngIf="!onlyIcon"
    tuiButton
    type="button"
    class="dropdown-button"
    [iconStart]="icon"
    [appearance]="appearance"
    [size]="size"
  >
    {{ label }}
  </button>

  <button
    *ngIf="onlyIcon"
    tuiIconButton
    type="button"
    class="dropdown-button"
    [iconStart]="icon"
    [appearance]="appearance"
    [size]="size"
    [tuiHint]="label"
  ></button>
</div>

<ng-template #dropdownContent>
  <ng-content></ng-content>
</ng-template>
